export enum ContactMethod {
  Email = 'EMAIL',
  Post = 'POST',
  SMS = 'SMS',
  Telephone = 'TELEPHONE',
}
